export default __webpack_public_path__ + "2ed56a3.png";